import React, { memo } from 'react'
import { Box, Grid2, Stack } from '@mui/material'

import PageTitle from '../shared/pageTitle/PageTitle'
import AppWelcome from './AppWelcome'
import PointsSummary from './PointsSummary'
import StakingSummary from './StakingSummary'
import AppFeatured from './AppFeatured'
import MainBanner from '../shared/mainBanner/MainBanner'
import HowItWorks from './HowItWorks'
import StakingFormContainer from '../../containers/staking/StakingFormContainer'

const Overview = ({
  accountProfile: { firstName, authId },
  t,
  symbol,
  receiveRewardCard,
  mainProfile,
  onCloseHowItWorks,
  closedHowItWorks,
  walletConnectProps,
  onOpenCOEStore
}) => {
  const howItWorksContent = (
    <HowItWorks
      t={t}
      symbol={symbol}
      onClose={onCloseHowItWorks}
      closed={closedHowItWorks}
    />
  )
  const summaryStack = (
    <Stack
      spacing={3}
      direction={closedHowItWorks ? { xs: 'column', sm: 'row' } : 'column'}
      sx={{ width: 1 }}
    >
      <PointsSummary t={t} mainProfile={mainProfile} symbol={symbol} />
      <StakingSummary t={t} />
    </Stack>
  )
  return (
    <>
      <PageTitle
        customTitle={t('navigation.home')}
        title={<>{t('home.welcome-back-user', { firstName })} 👑</>}
      />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Grid2 container spacing={3}>
            {closedHowItWorks ? (
              <Grid2 size={{ xs: 12 }}>{summaryStack}</Grid2>
            ) : (
              <Grid2 size={{ xs: 12 }}>{howItWorksContent}</Grid2>
            )}
            <Grid2 size={{ xs: 12 }}>
              <AppWelcome
                title={t('home.quick-navigation')}
                description={t('brand:home.quick-navigation-desc')}
                img={<MainBanner />}
                t={t}
                symbol={symbol}
                onOpenCOEStore={onOpenCOEStore}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <AppFeatured
                t={t}
                onOpenCOEStore={onOpenCOEStore}
                authId={authId}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>{receiveRewardCard()}</Grid2>
            {closedHowItWorks && (
              <Grid2 size={{ xs: 12 }}>{howItWorksContent}</Grid2>
            )}
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          {!closedHowItWorks && <Box mb={3}>{summaryStack}</Box>}
          <StakingFormContainer
            walletConnectProps={walletConnectProps}
            t={t}
            hideWallet
          />
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(Overview)
